import { Divider } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { dropdownMenu } from 'utils';
type ActionsDropDownProps = {
  items: any;
  setIsOpen: (arg0: boolean) => void;
};

const ActionsDropDown: React.FC<ActionsDropDownProps> = ({
  items,
  setIsOpen,
}) => {
  const navigate = useNavigate();
  return (
    <div style={{ marginTop: 2 }} className={'layout_header_profile_dropdown'}>
      <div className={'layout_header_menu_dropdown_wrapper'} style={{ borderBottom: '1px solid #75ACFF', padding: '16px' }}>
        <div
          style={{ fontWeight: 600, fontSize: 14, color: '#000000', }}
          className={'layout_header_menu_dropdown_menu'}
        >
          My Actions
        </div>
        <img
          onClick={() => setIsOpen(false)}
          src="/icons/close.svg"
          alt="close-icon"
          height={20}
          width={20}
        />
      </div>
      <Divider
        style={{ marginTop: '0px', marginBottom: '0px', color: '#75ACFF' }}
        orientation="left"
      />
      {items.map((item: dropdownMenu) => (
        <div
          onClick={() => {
            setIsOpen(false);
            if (item.name === 'Create a leave request') {
              navigate(item.routing);
            }
          }}
          key={item.id}
          style={item.disabled ? { opacity: '0.5', paddingLeft: '16px', borderRadius: '0px' } : { paddingLeft: '16px', borderRadius: '0px' }}
          className={'layout_header_menu_dropdown_item'}
        >
          <img src={item.image} alt={item.name} />
          <div style={{ fontWeight: 600, fontSize: 14, color: '#000000' }}>
            {item.name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActionsDropDown;
